(() => {
  const initCollectionShowcase = (root = document) => {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('[data-collection-showcase-slider]').forEach((slider) => {
      if (slider.swiper) return;

      const section = slider.closest('.collection-showcase');
      const products = section ? section.querySelector('.collection-showcase__products') : null;
      const nextButton = section ? section.querySelector('.collection-showcase__button--next') : null;
      const prevButton = section ? section.querySelector('.collection-showcase__button--prev') : null;

      const updateSliderEdges = (swiper) => {
        if (!products) return;

        products.classList.toggle('is-start', swiper.isBeginning);
        products.classList.toggle('is-end', swiper.isEnd);
      };

      const swiper = new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 3,
          },
        },
        on: {
          init: updateSliderEdges,
          slideChange: updateSliderEdges,
          reachBeginning: updateSliderEdges,
          reachEnd: updateSliderEdges,
          fromEdge: updateSliderEdges,
          resize: updateSliderEdges,
          breakpoint: updateSliderEdges,
        },
      });

      updateSliderEdges(swiper);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initCollectionShowcase());
  document.addEventListener('shopify:section:load', (event) => initCollectionShowcase(event.target));
})();
